import { render, staticRenderFns } from "./EditorTexto.vue?vue&type=template&id=4c01f18f"
import script from "./EditorTexto.vue?vue&type=script&lang=js"
export * from "./EditorTexto.vue?vue&type=script&lang=js"
import style0 from "./EditorTexto.vue?vue&type=style&index=0&id=4c01f18f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports